<template>
  <div class="bgfff out_wrap">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane v-for="tab in tabList" :key="tab.value" :label="tab.name" :name="tab.value" />
    </el-tabs>
    <keep-alive>
      <component
        :is="activeName"
        ref="tab"
      />
    </keep-alive>
  </div>
</template>

<script>
import EveryDay from './components/everyDay.vue'
import ReturnMoneyRecord from './components/returnMoneyRecord.vue'
export default {
  components: {
    EveryDay,
    ReturnMoneyRecord
  },
  data() {
    return {
      activeName: this.$route.query.tab || 'EveryDay',
      tabList: [{
        name: '每日流水汇总',
        value: 'EveryDay'
      }, {
        name: '返现记录',
        value: 'ReturnMoneyRecord'
      }]
    }
  },
  methods: {
    handleClick() {}
  }
}
</script>

<style>

</style>
